import React from 'react';
import { Card, Title, Table, TableHead, TableRow, TableHeaderCell, TableBody, TableCell, Button } from '@tremor/react';

export function RolesPermissionsPage() {
  const roles = [
    { 
      id: 1, 
      name: 'Admin', 
      description: 'Full system access', 
      userCount: 5 
    },
    { 
      id: 2, 
      name: 'Warehouse Manager', 
      description: 'Manage inventory and warehouse operations', 
      userCount: 8 
    },
    { 
      id: 3, 
      name: 'Finance Manager', 
      description: 'Access to financial reports and transactions', 
      userCount: 3 
    }
  ];

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <Title>Roles & Permissions</Title>
        <Button>+ New Role</Button>
      </div>

      <Card>
        <Table>
          <TableHead>
            <TableRow>
              <TableHeaderCell>Role Name</TableHeaderCell>
              <TableHeaderCell>Description</TableHeaderCell>
              <TableHeaderCell>Users</TableHeaderCell>
              <TableHeaderCell>Actions</TableHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {roles.map(role => (
              <TableRow key={role.id}>
                <TableCell>{role.name}</TableCell>
                <TableCell>{role.description}</TableCell>
                <TableCell>{role.userCount} users</TableCell>
                <TableCell>
                  <div className="space-x-2">
                    <Button size="xs" variant="secondary">Edit</Button>
                    <Button size="xs" variant="secondary">Permissions</Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
} 